import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import type { TimeRangePickerProps } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";

export const useSelectDate = () => {
  const [selectDate, setSelectDate] = useState<[Dayjs, Dayjs]>([dayjs().add(-6, "d"), dayjs()]);
  const rangePresets: TimeRangePickerProps["presets"] = [
    { label: "近七天", value: [dayjs().add(-6, "d"), dayjs()] },
    { label: "近30天", value: [dayjs().add(-29, "d"), dayjs()] },
    { label: "近一年", value: [dayjs().add(-1, "y"), dayjs()] },
  ];

  const disabledDate: RangePickerProps["disabledDate"] = (current, { from }) => {
    if (from) {
      return Math.abs(current.diff(from, "y")) >= 1;
    }
    return false;
  };

  return {
    selectDate,
    setSelectDate,
    rangePresets,
    disabledDate,
  };
};
